import { IFormMetadataCollection } from 'ui/components/form/IFormMetadata'
import { IBookForm } from 'ui/forms/formBook'

export type IAccountingCodeCatalogForm = IBookForm

export const accountingCodeCatalogFormMetadata: IFormMetadataCollection<IAccountingCodeCatalogForm> = {
	id: {
		readOnly: true,
	},
	name: {
		required: true,
	},
}
